import styled from "styled-components";
import { ProfileCashierButtonDefaultBox } from "./profile-cashier-button.default.box";

export const ProfileCashierButtonBallysDoverBox = styled(ProfileCashierButtonDefaultBox)`
    color: ${({theme}) => theme.sdk.colors.secondary };
    border-color: ${({theme}) => theme.sdk.colors.secondary };
    border: none;
    border-radius: 5px;
    @media ${({theme}) => theme.mediaQuery.lowHeight}, ${({theme}) => theme.mediaQuery.xlAndBelow} {
        line-height: 2.2;
    }
    font-family: ${({theme}) => theme.font.family.black};
`;
